import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const PoweredByContainer = styled.div`
  display: flex;
  align-items: flex-end;
  height: 54px;
`;

export const PoweredByLogo = styled.img`
  width: 76px;
  height: 54px;
`;

export const PoweredByText = styled.div`
  height: 13px;
  font-size: 10px;
  color: ${COLOR.OUTER_SPACE};
  margin-left: 10px;
  span {
    font-weight: bold;
  }
`;

export const VersionText = styled.div`
  height: 13px;
  font-size: 10px;
  color: ${COLOR.GUNSMOKE};
  margin-left: 8px;
`;
